// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","footer__title":"Footer_footer__title__dHoAa","footer__author":"Footer_footer__author__qgPzC"};